import ES from './es';
import EN from './en';

const clients = {
    ES,
    EN
};

export default clients;
